import { useEffect, useState } from 'react';

import { TextEditorBasic } from '@playbooks/molecules/editors';
import { Button } from '@playbooks/ui/components/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@playbooks/ui/components/dialog';
import { Field, FieldDescription } from '@playbooks/ui/components/field';

const ComposerMemoryDialog = ({
	open,
	setOpen,
	value = '',
	canManage = false,
	limit = 12000,
	description = '',
	onSave,
}) => {
	const [memory, setMemory] = useState(value || '');
	const [saving, setSaving] = useState(false);

	// Hooks
	useEffect(() => {
		if (open) setMemory(value || '');
	}, [open, value]);

	// Actions
	const onSubmit = async event => {
		event.preventDefault();
		if (!canManage) return setOpen(false);
		setSaving(true);
		try {
			await onSave(memory || null);
			setOpen(false);
		} finally {
			setSaving(false);
		}
	};

	// Render
	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogContent variant='form' className='sm:max-w-2xl'>
				<form onSubmit={onSubmit}>
					<DialogHeader>
						<DialogTitle>Memory</DialogTitle>
					</DialogHeader>
					<div>
						<Field>
							<TextEditorBasic
								value={memory}
								readOnly={!canManage}
								showToolbar={canManage}
								placeholder='Add priorities, terminology, and operating context…'
								className='[&_.ql-editor]:min-h-64'
								onChange={setMemory}
							/>
							<FieldDescription className='flex-between type-field-description'>
								<span>{description}</span>
								<span>
									{memory.length.toLocaleString()} / {limit.toLocaleString()}
								</span>
							</FieldDescription>
						</Field>
					</div>
					<DialogFooter>
						<Button type='button' variant='secondary' onClick={() => setOpen(false)}>
							{canManage ? 'Cancel' : 'Close'}
						</Button>
						{canManage ? (
							<Button type='submit' disabled={memory.length > limit} isLoading={saving}>
								Save
							</Button>
						) : null}
					</DialogFooter>
				</form>
			</DialogContent>
		</Dialog>
	);
};

export { ComposerMemoryDialog };
